import React from 'react'
import { Layout } from "../../common"
import { 
    CollectionHeaderSection, 
    ShopNFTSection } from "../../collection"
import { ProjectsSection } from "../../home"
import LogoSection from '../LogoSection'

const Collection = ({ isSignedIn, connectAction }) => {

    return (
        <Layout 
            header="transparent" 
            isSignedIn={isSignedIn} 
            connectAction={connectAction}
        >
            <CollectionHeaderSection />
            <ShopNFTSection />
            <LogoSection />
            {/* <ProjectsSection 
                title="Discover other projects"
                variant="grey"
            /> */}
        </Layout>
    )
}
export default Collection